import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DateInput',
  props: {
      date_label: { default: "Date (MM/DD/YYYY)", type: String},
      date_rules: { default: [], type: Array },
      modelValue: { type: [String, null], default: new Date() }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      menu: false,
      displayValue: '',
      internalDate: null,     // yyyy-mm-dd or null
      errorMessage: ''
    }
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.internalDate = newVal
          this.displayValue = this.formatMMDDYYYY(newVal)
        } else {
          this.internalDate = null
          this.displayValue = ''
        }
        this.errorMessage = ''
      }
    },

    internalDate(newIso) {
      if (newIso) {
        this.displayValue = this.formatMMDDYYYY(newIso)
        this.$emit('update:modelValue', newIso)
      } else {
        this.displayValue = ''
        this.$emit('update:modelValue', null)
      }
      this.errorMessage = ''
    }
  },

  methods: {
    formatMMDDYYYY(iso) {
      if (!iso) return ''
        try {
            if (iso instanceof Date) {
                return new Intl.DateTimeFormat('en-US', {
                    month: '2-digit',
                    day:   '2-digit',
                    year:  'numeric'
                }).format(iso);
            }
            else {
                const [yyyy, mm, dd] = iso.split('-')
                return `${mm}/${dd}/${yyyy}`
            }
      } catch {
        return ''
      }
    },

    parseMMDDYYYYToISO(str) {
      if (!str || str.length !== 10) return null
      const parts = str.split('/')
      if (parts.length !== 3) return null

      const mm = parseInt(parts[0], 10)
      const dd = parseInt(parts[1], 10)
      const yyyy = parseInt(parts[2], 10)

      if (
        isNaN(mm) || isNaN(dd) || isNaN(yyyy) ||
        mm < 1 || mm > 12 ||
        dd < 1 || dd > 31 ||
        yyyy < 1900 || yyyy > 2100
      ) {
        return null
      }

      return `${yyyy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`
    },

    handleTextInput(e) {
      let val = e.target.value.replace(/[^0-9/]/g, '')

      if (val.length === 2 && val[1] !== '/') val += '/'
      if (val.length === 5 && val[4] !== '/') val += '/'

      if (val.length > 10) val = val.substring(0, 10)

      this.displayValue = val

      if (val.length === 10) {
        const iso = this.parseMMDDYYYYToISO(val)
        if (iso) {
          this.internalDate = iso
        } else {
          this.errorMessage = 'Invalid date'
        }
      }
    },

    restrictKeys(e) {
      const allowed = ['0','1','2','3','4','5','6','7','8','9','/','Backspace','Delete','ArrowLeft','ArrowRight','Tab']

      if (e.ctrlKey || e.metaKey) return

      if (!allowed.includes(e.key)) {
        e.preventDefault()
        return
      }

      if (e.key === '/') {
        const count = (this.displayValue.match(/\//g) || []).length
        const pos = this.displayValue.length
        if (count >= 2 || (count === 0 && pos !== 1) || (count === 1 && pos !== 4)) {
          e.preventDefault()
        }
      }
    },

    validateOnBlur() {
      if (this.displayValue === '') {
        this.internalDate = null
        this.errorMessage = ''
        return
      }

      if (this.displayValue.length !== 10) {
        this.errorMessage = 'Please enter a complete date'
        return
      }

      const iso = this.parseMMDDYYYYToISO(this.displayValue)
      if (!iso) {
        this.errorMessage = 'Invalid date format'
      } else {
        this.internalDate = iso
        this.errorMessage = ''
      }
    }
  }
})
